import React, { useEffect, useState } from "react"
import "./DocumentRMO.scss"
import { useLocation, useParams } from "react-router"
import PedigreeView from "../../../../pages/PatientClinicalView/components/GeneticCounsellor/components/PedigreeView/PedigreeView"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import { Typography } from "@mui/material"
import { getAllDocumentUrl } from "../../../../core/services/api"
import HistoricalDocuments from "./HistoricalDocuments"

function DetailedDocument({ patientDetail }: any) {
  const [alldocuments, setdocuments] = useState<any>([])
  const [value, setValue] = React.useState(0)

  //setting up docs
  const location = useLocation()
  const appointmentId = new URLSearchParams(location.search).get(
    "appointmentId"
  )

  useEffect(() => {
    getAllDocs()
  }, [])

  function getAllDocs() {
    getAllDocumentUrl(patientDetail?.id)
      .then((res) => {
        console.log({ fileList: res })
        setdocuments(res)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }

  const updateDocs = (docs: any) => {
    setdocuments(docs)
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  interface TabPanelProps {
    children?: React.ReactNode
    index: number
    value: number
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props

    return (
      <div
        className="form-wrapper"
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    )
  }


  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    }
  }

  return (
    <div className="document-RMO">
      <div >
        <div>
          <Tabs
            TabIndicatorProps={{
              sx: {
                bgcolor: "blue",
                height: "2px",
                color: "blue",
              },
            }}
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              sx={{
                textTransform: "none",
                fontSize: "20px",
                fontWeight: "700",
              }}
              label="All Documents"
              {...a11yProps(0)}
            />
            <Tab
              sx={{
                textTransform: "none",
                fontSize: "20px",
                fontWeight: "700",
              }}
              label="Historical Data"
              {...a11yProps(1)}
            />
          </Tabs>
        </div>
        <TabPanel value={value} index={0}>
          <PedigreeView
            docs={alldocuments}
            appointmentId={appointmentId}
            updateDocs={updateDocs}
            patient={patientDetail}
            type={"DocumentRMO"}
            onDeleteFile={() => getAllDocs()}
            isReadOnly={false}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <HistoricalDocuments
            patient={patientDetail}
          />
        </TabPanel>
      </div>
    </div>
  )
}

export default DetailedDocument
